export default __webpack_public_path__ + "static/media/property_38.637a87e4.png";